/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/9/4 3:48 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

import ArtAutoComplete from './ArtAutoComplete';
import CustomerAutoComplete from './CustomerAutoComplete';
import ProductAutoComplete from './ProductAutoComplete';
import TermAutoComplete from './TermAutoComplete';
import YarnAutoComplete from './YarnAutoComplete';
import WarehouseAutoComplete from './WarehouseAutoComplete';
import CustUserNameAutoComplete from './CustUserNameAutoComplete';
import CollaboratorUserNameAutoComplete from './CollaboratorUserNameAutoComplete';
import CustomerMassageAutoComplete from './CustomerMassageAutoComplete';
import FibreAutoComplete from './FibreAutoComplete';
import UserAutoComplete from './UserAutoComplete';
import SaleOrderAutoComplete from './SaleOrderAutoComplete';
import GoodsSearchAutoComplete from './GoodsSearchAutoComplete';

export default {
  install(Vue) {
    Vue.component('ArtAutoComplete', ArtAutoComplete);
    Vue.component('CustomerAutoComplete', CustomerAutoComplete);
    Vue.component('ProductAutoComplete', ProductAutoComplete);
    Vue.component('TermAutoComplete', TermAutoComplete);
    Vue.component('YarnAutoComplete', YarnAutoComplete);
    Vue.component('WarehouseAutoComplete', WarehouseAutoComplete);
    Vue.component('CustUserNameAutoComplete', CustUserNameAutoComplete);
    Vue.component('CollaboratorUserNameAutoComplete', CollaboratorUserNameAutoComplete);
    Vue.component('CustomerMassageAutoComplete', CustomerMassageAutoComplete);
    Vue.component('FibreAutoComplete', FibreAutoComplete);
    Vue.component('UserAutoComplete', UserAutoComplete);
    Vue.component('SaleOrderAutoComplete', SaleOrderAutoComplete);
    Vue.component('GoodsSearchAutoComplete', GoodsSearchAutoComplete);
  }
};
